import React, { Suspense } from 'react';
import Home from './views/home';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import PrivacyComponent from './Pages/Privacy';
import CookieConsent from './views/components/Cookies';
import TermsOfService from './Pages/Terms';
import ContactForm from './views/components/Contact';
import Features from './views/components/Features';

function App() {
  return (
    <>
      <CookieConsent />
      <BrowserRouter>
        <Suspense fallback="">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features/>} />
              <Route path="" element={<ContactForm />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyComponent />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
